<div id="page" class="flex">
	<section class="inline" *ngFor="let schedule of facade.schedules(); index as i" [ngClass]="{ odd: i % 2 !== 0, even: i % 2 !== 1 }">
		<div (click)="goToRoute(schedule)" style="margin: 0pt; font-size: xx-small; color: gray">{{ schedule.id }}</div>
		<div (click)="goToRoute(schedule)" style="margin-bottom: .25em; font-size: 2vw; line-height: 1em; white-space: nowrap;">{{ schedule?.startTime }} - {{ schedule?.endTime }} {{
			schedule.summary }}</div>
		<p-table *ngIf="schedule.attendance" [value]="schedule.attendance">
			<ng-template pTemplate="header">
				<tr style="display: none;">
					<th pSortableColumn="shield">Tournaments</th>
					<th pSortableColumn="attendance">Attendance</th>
					<th pSortableColumn="name">member <p-sortIcon field="name"></p-sortIcon></th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-member let-idx="rowIndex">
				<tr style="height: 0;">
					<img id="cover" [src]="'/assets/' + (member.tournaments ? member.tournaments : 'none') + '.svg'" style="height: 1.75rem;" />
					<td><p-badge severity="success" [value]="member.attendanceTotal"></p-badge></td>
					<td pSortableColumn="member" [ngStyle]="{'font-size': '5vh', 'color': member.attended ? 'darkblue' : 'red', 'font-family': 'Passion One'}"> {{ member.name }} </td>
				</tr>
			</ng-template>
		</p-table>
	</section>
</div>